
import { Component, Vue } from "vue-property-decorator";
import FinderVue from "@/finder/Finder.vue";

import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();

import  ButtonVue from "@/lib/Button.vue";
import UploaderVue from "@/uploader/Uploader.vue";

import { MasterData } from "@/store/MasterData";
import Store from "@/store/Store";
import { IUser } from "@/../../server/src/user/IUser";
import { WykrojnikiCostSvc } from "@/wykrojniki/costdetail/WykrojnikiCostSvc";
import { OpSvc } from "@/tree/OpSvc";
import  JobPlanner  from "./plan/Plan.vue"
import  AiComponent  from "./AIVue.vue"
// import { MqttClient} from "./MqttClient"
// const mc = new MqttClient()
// mc.connect();

import  CompoTestVue  from "./compo/CompoTestVue.vue"

@Component({ components: { FinderVue, ButtonVue, UploaderVue, CompoTestVue, JobPlanner, AiComponent } })
export default class AdminVue extends Vue {

  _id:string="";
  key=0;

  topic:String="/MCU2SRV/TEST_API_KEY/30:ae:a4:cc:3c:40/counter"
  topics:String[]=[]
  program:String="";
  messages:String="";
  is_admin: boolean=false;

 async mounted() {
    console.log('mounted',this.$route.params.prj_id)
    this._id=this.$route.params.prj_id

    const user:IUser=bus.get_user();
   
    if (user.data_grupy.G_ADMIN) {
        this.is_admin=true;
    }

    //this.topics.push("/SVR2MCU/TEST_API_KEY/30:ae:a4:cc:3c:40/update")
    this.topics.push("/SVR2MCU/TEST_API_KEY/COUNTER_APP/restart")
     
  }

  async jobs() {
	let ret=await bus.call("/api/jobs/prjs_add_del_fnd",{ })
	console.log(ret)
  }

  async flow_test() {
	//let ret=await bus.call("/api/flow/zamowienie_polimerow_list",{ query:[] })
	//console.log(ret)

	//let q=[ '(','id','equal to',12,')',	'and','(','imie1','contains text like',	'KAM',	')',	'and',	'(',	'nazwisko',	'contains text like',	'GRAB',	')' ]

	//let q=[ '(', 'odbiorca_idn','contains text like',	'UNI',')']
	let ret=await bus.call("/api/flow/flowService/customerList",{ })
	console.log(ret)
  }


  async solis() {
    const ret=await bus.call("/api/solis",{  })
    console.log(ret)
  }

  async zlecenia_kontrolne_przelicz_all() {
    alert("Start obliczeń dla zleceń kontrolnych")
    const count = await new WykrojnikiCostSvc().zlecenia_kontrolne_przelicz_all();

    alert("Zakończono obliczenia dla zleceń kontrolnych");
  }

  created() {
  }

  beforeDestroy() {

  }

  async program_change() {

    if (!this.program) return;
    //await bus.call('/api/projekt/update', this.prj)
  }

	async  trees_to_operacje() {
		await new OpSvc(undefined, undefined).trees_to_operacje()
	}

}
